import { defineMessages } from 'react-intl';

import QA from './QATags';

export const FilterNavTypes = Object.freeze({
  ALL: 'all',
  ARTISTS: 'artists',
  SONGS: 'songs',
  STATIONS: 'stations',
  ALBUMS: 'albums',
  PLAYLISTS: 'playlists',
  PODCASTS: 'podcasts',
  EPISODES: 'episodes',
});

export const linkLabels = defineMessages({
  allLabel: {
    id: 't.allLabel',
    defaultMessage: 'All',
  },
  artistLabel: {
    id: 't.artistLabel',
    defaultMessage: 'Artists',
  },
  songLabel: {
    id: 't.songLabel',
    defaultMessage: 'Songs',
  },
  stationLabel: {
    id: 't.stationLabel',
    defaultMessage: 'Stations',
  },
  albumLabel: {
    id: 't.albumLabel',
    defaultMessage: 'Albums',
  },
  playlistLabel: {
    id: 't.playlistLabel',
    defaultMessage: 'Playlists',
  },
  podcastLabel: {
    id: 't.podcastLabel',
    defaultMessage: 'Podcasts',
  },
  episodesLabel: {
    id: 't.episodesLabel',
    defaultMessage: 'Episodes',
  },
});

export const FilterNavTypeLinks = Object.freeze({
  [FilterNavTypes.ALL]: {
    label: linkLabels.allLabel,
    qaTag: QA.MCALL,
  },
  [FilterNavTypes.ARTISTS]: {
    label: linkLabels.artistLabel,
    qaTag: QA.MCART,
  },
  [FilterNavTypes.ALBUMS]: {
    label: linkLabels.albumLabel,
    qaTag: QA.MCALB,
  },
  [FilterNavTypes.SONGS]: {
    label: linkLabels.songLabel,
    qaTag: QA.MCSONG,
  },
  [FilterNavTypes.STATIONS]: {
    label: linkLabels.stationLabel,
    qaTag: QA.MCST,
  },
  [FilterNavTypes.PLAYLISTS]: {
    label: linkLabels.playlistLabel,
    qaTag: QA.MCPL,
  },
  [FilterNavTypes.PODCASTS]: {
    label: linkLabels.podcastLabel,
    qaTag: QA.MCPC,
  },
  [FilterNavTypes.EPISODES]: {
    label: linkLabels.episodesLabel,
    qaTag: QA.MCPE,
  },
});

export const AllFilterTypes = Object.freeze([
  FilterNavTypes.ALL,
  FilterNavTypes.ARTISTS,
  FilterNavTypes.ALBUMS,
  FilterNavTypes.SONGS,
  FilterNavTypes.STATIONS,
  FilterNavTypes.PLAYLISTS,
  FilterNavTypes.PODCASTS,
]);

export const DefaultFilterTypes = Object.freeze([
  FilterNavTypes.ALL,
  FilterNavTypes.STATIONS,
  FilterNavTypes.PODCASTS,
]);
